module.exports = __webpack_public_path__ + "static/media/icons.b6e284ef.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/icons.woff?pv0exl
// module id = 2534
// module chunks = 7